import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  startAfter,
} from "firebase/firestore";
import { db } from "../../firebase";
import "../../styles/Viewvehicle.css";
import { useNavigate } from "react-router-dom";

function Viewvehicle1() {
  const [vehicles, setVehicles] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [modalImage, setModalImage] = useState(null);
  const navigate = useNavigate();
  // Filter states
  const [filterType, setFilterType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchVehicles();
    // eslint-disable-next-line
  }, []);

  // Vehicle type detection
  const getVehicleTypeFromSeries = (vehicleNumber) => {
    if (!vehicleNumber) return "Unknown";

    // Normalize: uppercase, remove spaces/dashes
    const normalized = vehicleNumber.toUpperCase().replace(/[\s-]/g, "");

    const specificVehicles = {
      "ABJ3284": "Lake Three-wheeler",
      "DAF5019": "Lake Geep",
      "GW3509": "Lake Lorry",
      "RA9999": "Tractor",
    };

    if (specificVehicles[normalized]) {
      return specificVehicles[normalized];
    }

    return "Other";
  };

  const fetchVehicles = async () => {
    if (loading) return;
    setLoading(true);

    try {
      let q;
      if (lastDoc) {
        q = query(
          collection(db, "vehicleScans"),
          orderBy("createdAt", "desc"),
          startAfter(lastDoc),
          limit(10)
        );
      } else {
        q = query(
          collection(db, "vehicleScans"),
          orderBy("createdAt", "desc"),
          limit(10)
        );
      }

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const newData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setVehicles((prev) => {
          const existingIds = new Set(prev.map((item) => item.id));
          const uniqueData = newData.filter((item) => !existingIds.has(item.id));
          return [...prev, ...uniqueData];
        });

        setLastDoc(snapshot.docs[snapshot.docs.length - 1]);
        setPage((prev) => prev + 1);
        if (snapshot.docs.length < 10) setHasMore(false);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    }

    setLoading(false);
  };

  // Filter vehicles based on type and date range
  const filteredVehicles = vehicles.filter((vehicle) => {
    // Only Centauria Lake
    if (!vehicle.hotelName || vehicle.hotelName.toLowerCase() !== "centauria lake") return false;

    // Vehicle type filter
    const type = getVehicleTypeFromSeries(vehicle.vehicleNumber);
    if (filterType && type !== filterType) return false;

    // Date range filter
    const createdDate = vehicle.createdAt?.toDate ? vehicle.createdAt.toDate() : null;
    if (createdDate) {
      if (startDate && createdDate < new Date(startDate)) return false;
      if (endDate && createdDate > new Date(endDate + "T23:59:59")) return false;
    }

    return true;
  });

  return (
    <div className="viewvehicle-container">
      <h2>Captured Vehicle Records</h2>

      <button
        onClick={() => navigate("/avs")}
        className="history-btn"
      >
        Vehicles Summary 
      </button>

      {/* Filter Section */}
      <div className="filter-section">
        <label>
          Vehicle Type:{" "}
          <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
            <option value="">All</option>
            <option value="Car">Car</option>
            <option value="Lake Lorry">Lorry</option>
            <option value="Motorcycle">Motorcycle</option>
            <option value="Bus">Bus</option>
            <option value="Lake Three-wheeler">Three-wheeler</option>
            <option value="Lake Geep">Geep</option>
            <option value="Tractor">Tractor</option>
            <option value="Heavy Vehicle">Heavy Vehicle</option>
            <option value="Other">Other</option>
          </select>
        </label>

        <label>
          From:{" "}
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>

        <label>
          To:{" "}
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>
      </div>

      <div className="vehicle-table-wrapper">
        {filteredVehicles.length === 0 && !loading ? (
          <p>No records found.</p>
        ) : (
          <table className="vehicle-table">
            <thead>
              <tr>
                <th>Date & Time</th>
                <th>Vehicle Type</th>
                <th>Vehicle Number</th>
                <th>Direction</th>
                <th>Purpose</th>
                <th>Meter Reading</th>
                {/* <th>Scanned Image</th> */}
                <th>Uploaded Image</th>
                <th>User</th>
              </tr>
            </thead>

            <tbody>
              {Object.entries(
                filteredVehicles.reduce((groups, vehicle) => {
                  const hotel = vehicle.hotelName || "Unknown Hotel";
                  if (!groups[hotel]) groups[hotel] = [];
                  groups[hotel].push(vehicle);
                  return groups;
                }, {})
              ).map(([hotel, hotelVehicles]) => (
                <React.Fragment key={hotel}>
                  <tr className="hotel-row">
                    <td colSpan="9" style={{ textAlign: "center", fontWeight: "bold" }}>
                      {hotel}
                    </td>
                  </tr>

                  {hotelVehicles.map((vehicle) => (
                    <tr key={vehicle.id}>
                      <td>
                        {vehicle.createdAt?.toDate
                          ? `${vehicle.createdAt.toDate().toLocaleDateString("en-GB")} ${vehicle.createdAt
                              .toDate()
                              .toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              })}`
                          : "N/A"}
                      </td>
                      <td>{getVehicleTypeFromSeries(vehicle.vehicleNumber)}</td>
                      <td>{vehicle.vehicleNumber || "N/A"}</td>
                      <td>{vehicle.vehicleDirection || "N/A"}</td>
                      <td>{vehicle.purpose || "N/A"}</td>
                      <td>{vehicle.meter || "N/A"}</td>
                      {/* <td>
                        {vehicle.scannedImage ? (
                          <img
                            src={vehicle.scannedImage}
                            alt="Scanned"
                            className="vehicle-img"
                            loading="lazy"
                            onClick={() => setModalImage(vehicle.scannedImage)}
                          />
                        ) : (
                          "N/A"
                        )}
                      </td> */}
                      <td>
                        <div className="thumbnail-row">
                          {vehicle.uploadedUrls && vehicle.uploadedUrls.length > 0 ? (
                            vehicle.uploadedUrls.map((url, idx) => (
                              <img
                                key={idx}
                                src={url}
                                alt={`Uploaded ${idx + 1}`}
                                className="vehicle-img"
                                loading="lazy"
                                onClick={() => setModalImage(url)}
                              />
                            ))
                          ) : (
                            "N/A"
                          )}
                        </div>
                      </td>
                      <td>
                        {vehicle.userEmail
                          ? vehicle.userEmail.split("@")[0] // show only the part before "@"
                          : "N/A"}
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        )}

        <div className="load-more">
          {loading && <p>Loading...</p>}
          {!loading && hasMore && (
            <button onClick={fetchVehicles} className="load-more-btn" disabled={loading}>
              {loading ? "Loading..." : "Load More"}
            </button>
          )}
          {!hasMore && filteredVehicles.length > 0 && <p>No more records</p>}
        </div>

        {modalImage && (
          <div className="image-modal" onClick={() => setModalImage(null)}>
            <img src={modalImage} alt="Large" className="modal-img" />
          </div>
        )}
      </div>
    </div>
  );
}

export default Viewvehicle1;
